import {
  appendToArray,
  removeFromArray,
  objectWithAccessorsList,
  withProperties,
  isPlainObject,
  isString,
  isFunction
} from "../../../utils";

const hasProperty = Function.prototype.call.bind(Object.prototype.hasOwnProperty);

function objectWithReactiveFields(...fields) {
  const subscriptions = withProperties(Object.create(null), (
    fields.reduce((fieldsSubscriptionsObject, field) => {
      if (isString(field) || typeof field === 'symbol') {
        fieldsSubscriptionsObject[field] = [];
      }
      return fieldsSubscriptionsObject;
    }, {})
  ), true);

  return Object.defineProperties(objectWithAccessorsList.call(this, subscriptions, false), {
    $subscribe: {
      value(field, ...fns) {
        if (hasProperty(subscriptions, field)) {
          fns.forEach(fn => {
            isFunction(fn) && (
              subscriptions[field] = appendToArray(subscriptions[field], fn)
            );
          });
        }
      }
    },

    $unsubscribe: {
      value(field, ...fns) {
        if (hasProperty(subscriptions, field)) {
          fns.forEach(fn => {
            subscriptions[field] = removeFromArray(subscriptions[field], fn);
          });
        }
      }
    }
  });
}

function withReactiveFields($context, ...fields) {
  if (!(isPlainObject($context) && Object.isExtensible($context))) {
    throw new Error('Cannot setup reactive fields without appropriate context object.');
  }

  return objectWithReactiveFields.call($context, ...fields);
}

export { objectWithReactiveFields };

export default withReactiveFields;
